/**
 * Подсказки обучения, зависящие от роли (07-20). Замаскированный текст запроса LLM видит
 * только администратор (контракты §5; учебный фасад отдаёт его так же), поэтому подсказки
 * про метки [EMAIL_1] и [PHONE_1] у остальных ролей заменены подсказками о том, что им видно:
 * найденные в запросе данные события.
 */

/** Подсказки, обещающие замаскированный текст запроса: путь в словаре learning без .hint */
const MASKED_PROMPT_HINTS: ReadonlySet<string> = new Set([
	'steps.ai-masking',
	'exercises.ai.goals.masked',
]);

/** Ключ подсказки шага или цели для роли; canReadMaskedPrompt -- право администратора */
export function hintKey(path: string, canReadMaskedPrompt: boolean): string {
	return !canReadMaskedPrompt && MASKED_PROMPT_HINTS.has(path)
		? `learning:${path}.hintMember`
		: `learning:${path}.hint`;
}
